<script>
  import {styleVars} from '/helper'
  import ContentBox from '/components/Atoms/Card.svelte'

  export let title, bgColorKey = "mint", info = false, link = null, nohole = false

  const borderRadiusPreset = {
    large: [60, 60, 20, 20],
    small: [35, 35, 15, 15]
  }

</script>

<ContentBox {bgColorKey} {nohole} {borderRadiusPreset} {info} {link} paddingStyle="headline">
  <h3 class="title">
    <slot />
  </h3>
</ContentBox>

<style lang="scss">


  .title {
    @include typo-serif-title-44;
    text-align: center;
    padding: 0 #{ $hole-diameter-large + $hole-distance-large/2 };
    @include media-small {
      padding: 0 #{ $hole-diameter-small + $hole-distance-small/2 };
    }

  }
</style>

